import { render, staticRenderFns } from "./candle-chart.vue?vue&type=template&id=663135a2&scoped=true&"
import script from "./candle-chart.vue?vue&type=script&lang=js&"
export * from "./candle-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663135a2",
  null
  
)

export default component.exports